module.exports = __webpack_public_path__ + "static/media/hospital-symbol.0588e641.svg";